import { useSidebar } from "./index";
import { cn } from "../../lib/utils";

const SidebarHeader = ({ title, actions, children }) => {
	const { side } = useSidebar();

	return (
		<div
			className={cn(
				"shadow-[0_2px_8px] shadow-dark-100/10 pt-5 pb-5 relative z-10 bg-white flex flex-col gap-4 w-full",
				side === "left" && "pl-9 pr-7",
				side === "right" && "pl-7 pr-9"
			)}
		>
			{(title || actions) && (
				<div className="flex gap-4 justify-between items-center">
					{title && <div className="uppercase font-bold text-dark-50 text-13">{title}</div>}

					{actions && <div className="flex gap-3">{actions}</div>}
				</div>
			)}

			{children}
		</div>
	);
};

export default SidebarHeader;
